import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { config } from '../../config';

export default function GestionPrimes() {
    const [primes, setPrimes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showForm, setShowForm] = useState(false);
    const [editing, setEditing] = useState(null);
    const [form, setForm] = useState({ nom_prime: '', valeur: '', description: '' });

    // Utilisation de la configuration centralisée
    const API_BASE = `${config.apiBase}/rh`;

    const fetchPrimes = async () => {
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`${API_BASE}/lister_primes.php`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const data = await res.json();
            if (data.success) setPrimes(data.primes);
        } catch (error) {
            toast.error('Erreur chargement');
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('token');
            const url = editing ? `${API_BASE}/modifier_prime.php` : `${API_BASE}/ajouter_prime.php`;
            const payload = editing ? { ...form, id_prime: editing } : form;
            const res = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                body: JSON.stringify(payload)
            });
            const data = await res.json();
            if (data.success) {
                toast.success(editing ? 'Prime modifiée' : 'Prime ajoutée');
                setShowForm(false);
                setEditing(null);
                setForm({ nom_prime: '', valeur: '', description: '' });
                fetchPrimes();
            } else toast.error(data.message);
        } catch (error) {
            toast.error('Erreur réseau');
        }
    };

    const handleDelete = async (id, nom) => {
        if (!window.confirm(`Supprimer la prime ${nom} ?`)) return;
        const token = localStorage.getItem('token');
        try {
            const res = await fetch(`${API_BASE}/supprimer_prime.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                body: JSON.stringify({ id_prime: id })
            });
            const data = await res.json();
            if (data.success) {
                toast.success('Prime supprimée');
                fetchPrimes();
            } else toast.error(data.message);
        } catch (error) {
            toast.error('Erreur suppression');
        }
    };

    useEffect(() => { fetchPrimes(); }, []);

    if (loading) return <div className="p-6 text-center">Chargement...</div>;

    return (
        <div className="p-6">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-2xl font-bold text-blue-800">💰 Gestion des primes et indemnités</h1>
                <button onClick={() => { setEditing(null); setForm({ nom_prime: '', valeur: '', description: '' }); setShowForm(true); }} className="bg-blue-600 text-white px-4 py-2 rounded">+ Ajouter une prime</button>
            </div>

            <div className="overflow-x-auto bg-white rounded-xl shadow">
                <table className="min-w-full text-sm">
                    <thead className="bg-gray-100">
                        <tr><th className="p-2">Nom</th><th className="p-2">Valeur (FCFA)</th><th className="p-2">Description</th><th className="p-2">Actions</th></tr>
                    </thead>
                    <tbody>
                        {primes.map(p => (
                            <tr key={p.id_prime} className="border-b hover:bg-gray-50">
                                <td className="p-2">{p.nom_prime}</td>
                                <td className="p-2">{parseInt(p.valeur).toLocaleString()} F</td>
                                <td className="p-2">{p.description || '-'}</td>
                                <td className="p-2">
                                    <button onClick={() => { setEditing(p.id_prime); setForm(p); setShowForm(true); }} className="text-blue-600 mr-2">✏️</button>
                                    <button onClick={() => handleDelete(p.id_prime, p.nom_prime)} className="text-red-500">🗑️</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {showForm && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-xl w-full max-w-md p-6">
                        <h2 className="text-xl font-bold mb-4">{editing ? 'Modifier' : 'Ajouter'} une prime</h2>
                        <form onSubmit={handleSubmit} className="space-y-3">
                            <input type="text" placeholder="Nom de la prime *" className="w-full border p-2 rounded" value={form.nom_prime || ''} onChange={e => setForm({ ...form, nom_prime: e.target.value })} required />
                            <input type="number" placeholder="Valeur (FCFA) *" className="w-full border p-2 rounded" value={form.valeur || ''} onChange={e => setForm({ ...form, valeur: e.target.value })} required />
                            <textarea placeholder="Description (facultatif)" rows="2" className="w-full border p-2 rounded" value={form.description || ''} onChange={e => setForm({ ...form, description: e.target.value })} />
                            <div className="flex justify-end gap-2 mt-2">
                                <button type="button" onClick={() => setShowForm(false)} className="bg-gray-400 text-white px-4 py-2 rounded">Annuler</button>
                                <button type="submit" className="bg-green-600 text-white px-4 py-2 rounded">{editing ? 'Modifier' : 'Ajouter'}</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}